import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { payout } from "../../rbac-consts";
import { default as ClientPayoutContainer } from "./client/PayoutContainer";
import { default as SupportPayoutContainer } from "./support/PayoutContainer";
import { default as AdminPayoutContainer } from "./admin/PayoutContainer";
import { default as SuperAdminPayoutContainer } from "./superAdmin/PayoutContainer";

const PayoutWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={payout.USER}
        yes={() => (
          <ClientPayoutContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={payout.SUPPORT}
        yes={() => (
          <SupportPayoutContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={payout.ADMIN}
        yes={() => (
          <AdminPayoutContainer />
        )}
      />
      <Can
        role={user.roles}
        perform={payout.SUPER_ADMIN}
        yes={() => (
          <SuperAdminPayoutContainer />
        )}
      />
    </>
  );
};

export default PayoutWrapper;